<template>
  <div class="sales">
    <div class="nav"><router-link to="/">← dimaverov.com</router-link></div>
    <h1>{{ meta.title || 'Продаю всякое' }}</h1>
    <p class="sub" v-if="loaded">
      {{ meta.city }}. Пишите в Telegram:
      <a :href="meta.contact_url" target="_blank" rel="noopener">{{ meta.contact_label }}</a>
      · канал <a :href="meta.channel_url" target="_blank" rel="noopener">@{{ meta.channel_username }}</a>
    </p>
    <p class="sub" v-else-if="error">Не удалось загрузить список — смотри <a href="https://t.me/supersale0001">канал</a>.</p>
    <p class="sub" v-else>Загружаю…</p>

    <div class="tabs">
      <button v-for="t in tabs" :key="t.key" class="tab" :class="{ on: filter === t.key }" @click="filter = t.key">
        {{ t.label }}<b>{{ t.count }}</b>
      </button>
    </div>

    <div class="grid">
      <div v-for="it in visible" :key="it.id" class="card" :class="[it.status, { open: opened[it.id] }]">
        <div class="ph">
          <a v-if="it.photos && it.photos.length" :href="img(it.photos[0])" target="_blank" rel="noopener">
            <img loading="lazy" :src="img(it.photos[0])" :alt="it.title">
          </a>
          <div v-else class="noimg">фото в канале</div>
          <span class="badge" :class="it.status">{{ label[it.status] }}</span>
          <span class="n">#{{ it.id }}</span>
          <span v-if="it.photos && it.photos.length > 1" class="more">+{{ it.photos.length - 1 }} фото</span>
        </div>
        <div class="body">
          <div class="t">{{ it.title }}</div>
          <div class="p" :class="{ free: !(it.price > 0) }">{{ price(it) }}</div>
          <div class="d" v-if="it.description">{{ it.description }}</div>
          <button v-if="it.description && it.description.length > 140" class="toggle" @click="opened[it.id] = !opened[it.id]">
            {{ opened[it.id] ? 'свернуть ▴' : 'подробнее ▾' }}
          </button>
          <div class="acts">
            <a class="btn main" :href="ask(it)" target="_blank" rel="noopener">{{ it.status === 'reserved' ? 'В очередь' : 'Написать' }}</a>
            <a v-if="it.tg_message_id" class="btn" :href="post(it)" target="_blank" rel="noopener">Пост</a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loaded && !visible.length" class="empty">Тут пока пусто.</div>

    <p class="foot" v-if="loaded">
      Статусы обновляются автоматически<span v-if="meta.updated_at"> · обновлено {{ updated }}</span>.<br>
      «Бронь» — за вещью уже собираются прийти; можно встать в очередь на случай, если не заберут.
    </p>
  </div>
</template>

<script>
// Vue 3, Options API. Данные: /sales-data/items.json (их пишет телеграм-бот), картинки: /sales-data/img/*.jpg
// (каталог называется не /sales, чтобы nginx не перехватывал роут SPA существующей директорией)
const ORDER = { available: 0, reserved: 1, sold: 2 };
const BASE = '/sales-data/';

export default {
  name: 'SalesView',
  data() {
    return {
      meta: {}, items: [], loaded: false, error: false,
      filter: (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('f')) || 'available',
      opened: {},
      label: { available: 'Доступно', reserved: 'Бронь', sold: 'Продано' },
    };
  },
  computed: {
    tabs() {
      const c = { all: this.items.length, available: 0, reserved: 0, sold: 0 };
      this.items.forEach(i => { c[i.status] = (c[i.status] || 0) + 1; });
      return [
        { key: 'available', label: 'Доступно', count: c.available },
        { key: 'reserved', label: 'Бронь', count: c.reserved },
        { key: 'sold', label: 'Продано', count: c.sold },
        { key: 'all', label: 'Все', count: c.all },
      ];
    },
    visible() {
      return this.items
        .filter(i => this.filter === 'all' || i.status === this.filter)
        .slice()
        .sort((a, b) => (ORDER[a.status] - ORDER[b.status]) || (a.id - b.id));
    },
    updated() {
      return new Date(this.meta.updated_at).toLocaleString('ru-RU', { day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' });
    },
  },
  methods: {
    img(p) { return BASE + p; },
    price(it) { return it.price > 0 ? `${it.price} ${this.meta.currency}` : 'Бесплатно'; },
    post(it) { return `https://t.me/${this.meta.channel_username}/${it.tg_message_id}`; },
    ask(it) {
      const txt = `Привет! Интересует лот #${it.id} «${it.title}»` + (it.price > 0 ? ` за ${it.price} ${this.meta.currency}` : '');
      return `${this.meta.contact_url}?text=${encodeURIComponent(txt)}`;
    },
  },
  async created() {
    document.title = 'Продаю всякое — dimaverov.com';
    try {
      const r = await fetch(`${BASE}items.json?t=${Date.now()}`, { cache: 'no-store' });
      const j = await r.json();
      this.meta = j.meta || {}; this.items = j.items || []; this.loaded = true;
    } catch (e) { this.error = true; }
  },
  unmounted() { document.title = 'Watch you step'; },
};
</script>

<style>
/* глобально: #app в Home.vue задан фиксированной шириной 1000px — на телефоне не влезает */
#app { width: auto; max-width: 1000px; padding: 0 16px; box-sizing: border-box; }
@media (max-width: 600px) { #app { margin-top: 40px; } }
</style>

<style scoped>
.sales{text-align:left}
.nav{padding:0 0 30px;font-weight:700}
.nav a{color:#2c3e50}
h1{font-size:28px;margin:0 0 6px}
.sub{color:#7f8c9a;margin:0 0 22px;line-height:1.5}
.sub a{color:#42b983;font-weight:700}
.tabs{display:flex;flex-wrap:wrap;gap:8px;margin:0 0 20px}
.tab{border:1px solid #e6eaee;border-radius:999px;padding:7px 14px;cursor:pointer;background:#fff;font:inherit;color:#2c3e50}
.tab.on{background:#2c3e50;color:#fff;border-color:#2c3e50}
.tab b{font-weight:400;opacity:.7;margin-left:4px}
.grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(230px,1fr));gap:18px}
.card{border:1px solid #e6eaee;border-radius:14px;overflow:hidden;display:flex;flex-direction:column;transition:box-shadow .15s;background:#fff}
.card:hover{box-shadow:0 6px 24px rgba(44,62,80,.10)}
.ph{position:relative;aspect-ratio:4/3;background:#f2f4f6;overflow:hidden}
.ph img{width:100%;height:100%;object-fit:cover;display:block}
.noimg{display:flex;align-items:center;justify-content:center;height:100%;color:#7f8c9a;font-size:13px}
.badge{position:absolute;top:10px;left:10px;font-size:12px;font-weight:700;padding:4px 9px;border-radius:999px;color:#fff}
.badge.available{background:#42b983}.badge.reserved{background:#e6a700}.badge.sold{background:#c0392b}
.n{position:absolute;top:10px;right:10px;font-size:11px;background:rgba(44,62,80,.75);color:#fff;padding:3px 7px;border-radius:6px}
.more{position:absolute;bottom:8px;right:10px;font-size:11px;background:rgba(0,0,0,.55);color:#fff;padding:3px 7px;border-radius:6px}
.body{padding:12px 14px 14px;display:flex;flex-direction:column;gap:8px;flex:1}
.t{font-weight:700;line-height:1.3}
.p{font-size:18px;font-weight:700}.p.free{color:#42b983}
.d{font-size:13px;color:#4a5b6b;line-height:1.45;display:-webkit-box;-webkit-line-clamp:4;-webkit-box-orient:vertical;overflow:hidden}
.card.open .d{-webkit-line-clamp:unset}
.toggle{font-size:12px;color:#7f8c9a;cursor:pointer;background:none;border:0;padding:0;text-align:left;font-family:inherit}
.acts{display:flex;gap:8px;margin-top:auto;padding-top:4px}
.btn{flex:1;text-align:center;font-size:13px;font-weight:700;padding:8px 6px;border-radius:9px;border:1px solid #e6eaee;color:#2c3e50}
.btn.main{background:#42b983;border-color:#42b983;color:#fff}
.card.sold .ph img{filter:grayscale(1);opacity:.55}
.card.sold .t,.card.sold .p{text-decoration:line-through;color:#7f8c9a}
.card.sold .btn.main{display:none}
.card.reserved .btn.main{background:#fff;color:#2c3e50;border-color:#e6eaee}
.empty{color:#7f8c9a;padding:40px 0;text-align:center}
.foot{margin-top:40px;font-size:13px;color:#7f8c9a;line-height:1.6}
@media (max-width:520px){.grid{grid-template-columns:repeat(2,1fr);gap:10px}.body{padding:10px}.t{font-size:14px}.d{display:none}.card.open .d{display:-webkit-box}.p{font-size:16px}}
</style>
